"use strict";

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
var react_1 = __importDefault(require("react"));
var ChromeExtensionStore = function ChromeExtensionStore(props) {
  return react_1.default.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 2225.3 1921.9"
  }, props), react_1.default.createElement("path", {
    fill: "#eee",
    d: "M1365.5 404.7H859.8a101.2 101.2 0 110-202.3h505.7a101.2 101.2 0 110 202.3zM0 0v1770.2c0 83.4 68.3 151.7 151.7 151.7h1921.9c83.4 0 151.7-68.3 151.7-151.7V0H0z"
  }), react_1.default.createElement("path", {
    fill: "#db4437",
    d: "M1112.7 809.2a960 960 0 00-808.3 441.1v671.5h468.5l339.8-588.6h856.1a961.1 961.1 0 00-856.1-524z"
  }), react_1.default.createElement("path", {
    fill: "#0f9d58",
    d: "M304.1 1250.7a956.8 956.8 0 00-152.4 519.5c0 51.6 4.1 102.3 12 151.7h531.8l-391.4-671.2z"
  }), react_1.default.createElement("path", {
    fill: "#ffcd40",
    d: "M2073.6 1770.2a957.3 957.3 0 00-104.8-436.9h-856.1l339.8 588.6h609.1c7.9-49.4 12-100.1 12-151.7z"
  }), react_1.default.createElement("path", {
    fill: "#f1f1f1",
    d: "M1112.7 1333.3A436.8 436.8 0 00703 1921.9h94.8a349.5 349.5 0 11629.8 0h94.8a436.9 436.9 0 00-409.7-588.6z"
  }), react_1.default.createElement("path", {
    fill: "#4285f4",
    d: "M1112.7 1420.7a349.5 349.5 0 00-314.9 501.2h629.8a349.5 349.5 0 00-314.9-501.2z"
  }), react_1.default.createElement("path", {
    opacity: ".1",
    fill: "#212121",
    d: "M0 0v961h2225.3V0H0zm1365.5 404.7H859.8a101.2 101.2 0 110-202.3h505.8a101.2 101.2 0 11-.1 202.3z"
  }), react_1.default.createElement("path", {
    opacity: ".1",
    fill: "#fff",
    d: "M0 961h2225.3v12.7H0z"
  }), react_1.default.createElement("path", {
    opacity: ".1",
    fill: "#231f20",
    d: "M2073.6 1909.2H151.7A152.1 152.1 0 010 1757.5v12.7c0 83.4 68.3 151.7 151.7 151.7h1921.9c83.4 0 151.7-68.3 151.7-151.7v-12.7c0 83.5-68.3 151.7-151.7 151.7zM859.8 202.3h505.7a101 101 0 01100.8 94.8c.1-2.1.4-4.2.4-6.3 0-55.9-45.3-101.2-101.2-101.2H859.8A101.2 101.2 0 00759 297.1a101 101 0 01100.8-94.8z"
  }));
};
exports.default = ChromeExtensionStore;